import { Alert, Text } from '@capsicum/common-web';
import { AlertIcon } from '@capsicum/common-web/icons';
import { useNCWDepositAddressCHZ } from '@capsicum/features/nc-wallet/shared';
import styled from 'styled-components';

import { NCWAddressCopyCard } from '../../ui';

/**
 * Content for a page that displays the Chiliz Chain address
 */
export const NCWDepositAddressCHZ = () => {
	const { intlText } = useNCWDepositAddressCHZ();

	return (
		<S.Wrapper>
			<Text variant="title5">{intlText.pageTitle}</Text>
			<NCWAddressCopyCard />
			<S.ReceiveAlert closable={false} icon={AlertIcon} subTitle={intlText.alertText} type="important" />
		</S.Wrapper>
	);
};

namespace S {
	export const Wrapper = styled.div`
		margin-top: ${({ theme }) => theme.spacings.xxlarge};
		display: flex;
		gap: ${({ theme }) => theme.spacings.small};
		flex-flow: column;
		width: 100%;
		padding: ${({ theme }) => `0 ${theme.spacings.xsmall}`};
		background-color: ${({ theme }) => theme.colors.backgrounds.main.screen};
	`;

	export const ReceiveAlert = styled(Alert)`
		margin-top: ${({ theme }) => theme.spacings.medium};
	`;
}
